import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets-wrfwihn1.emergentagent.net/job_living-hope-redesign/artifacts/qylgio7e_LHCC_Logo_Circle_BL_WB_WEB-01mobile.png';

// Official Living Hope Community Church logo (white version) — used on dark backgrounds
const Logo = ({ compact = false }) => {
  return (
    <Link to="/" className="flex items-center group">
      <img
        src={LOGO_URL}
        alt="Living Hope Community Church"
        className={`${compact ? 'h-10' : 'h-12 md:h-14'} w-auto object-contain transition-transform duration-500 group-hover:scale-105`}
      />
    </Link>
  );
};

export default Logo;
